import React from 'react';
import { Button } from 'react-bootstrap';
import { navigate } from 'gatsby';
import dog from '../../assets/dog.png';
import food from '../../assets/food.png';
import delivery from '../../assets/delivery.png';
import HowItemCard from '../common/InfoItemsCard/InfoItemsCard';

const HowSection = (props: { isTester: any; }) => {
  // Array to store HowItemCard content
  const howItems = [
    {
      imgSrc: dog,
      imgAlt: "dog",
      imgTitle: "dog",
      title: "Tell us about your Furbaby",
      description: "Answer a few quick questions about your dog like age, weight, activity level."
    },
    {
      imgSrc: food,
      imgAlt: "food",
      imgTitle: "food",
      title: "Create a personalised meal plan",
      description: "We’ll let you know how many calories your dog needs and help you create their personalised feeding plan."
    },
    {
      imgSrc: delivery,
      imgAlt: "delivery",
      imgTitle: "delivery",
      title: "Automate Your Deliveries",
      description: "Get the perfect amount of natural, NZ made dog food delivered to your door, when you need it."
    }
  ];

  return (
    <div className="how-wrapper" data-title="Buy dog food Online NZ. Dog food subscription delivery - Furbaby">
      <div className="container-fluid">
        <div className="how-hdr">
          <h2 className="mgn-bot-20">
            NZ's best dog biscuits, delivered to your door
          </h2>
          <p>
            We deliver super healthy natural dog food to your door, with a
            delivery plan made just for your furbaby. <br />
            Our flexible plans deliver the best dog food NZ has to offer, right
            when you need it.
          </p>
        </div>

        <div className="how-card def-w-max pdd-top-40">
          <h2>{props.isTester ? 'How does Feed My Furbaby subscription work?' : 'How it works?'}</h2>
          <div className="row justify-content-center">
            {howItems.map((item, index) => (
              <HowItemCard
                key={index}
                imgSrc={item.imgSrc}
                imgAlt={item.imgAlt}
                imgTitle={item.imgTitle}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
          <Button
            className="btn-txt btn-txt-org txt-underline"
            onClick={() => navigate('/howitworks')}>
            Learn more about how our dog food subscription works
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HowSection;
